import React, { ReactElement } from 'react';
import { theme } from 'theme';
import makeStyles from '@material-ui/styles/makeStyles';
import clsx from 'clsx';

const useStyles = makeStyles({
  root: {
    '&:hover path': {
      fill: theme.palette.primary.main,
    },
  },
});

export const QuestionMarkIcon = ({
  width = 12,
  height = 11,
  fill = theme.palette.common.strongViolet,
  className,
  ...restProps
}): ReactElement => {
  const classes = useStyles();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(classes.root, className)}
      {...restProps}
    >
      <path
        d="M6 10.9961C4.44531 10.957 3.14844 10.4219 2.10938 9.39062C1.07812 8.35156 0.542969 7.05469 0.503906 5.5C0.542969 3.94531 1.07812 2.65234 2.10938 1.62109C3.14844 0.582031 4.44531 0.0429688 6 0.00390625C7.55469 0.0429688 8.84766 0.582031 9.87891 1.62109C10.918 2.65234 11.457 3.94531 11.4961 5.5C11.457 7.05469 10.918 8.35156 9.87891 9.39062C8.84766 10.4219 7.55469 10.957 6 10.9961ZM6 10C7.27344 9.96875 8.33203 9.53125 9.17578 8.6875C10.0273 7.83594 10.4688 6.77344 10.5 5.5C10.4688 4.22656 10.0273 3.16797 9.17578 2.32422C8.33203 1.47266 7.27344 1.03125 6 1C4.72656 1.03125 3.66406 1.47266 2.8125 2.32422C1.96875 3.16797 1.53125 4.22656 1.5 5.5C1.53125 6.77344 1.96875 7.83594 2.8125 8.6875C3.66406 9.53125 4.72656 9.96875 6 10ZM6 8.5C5.90625 8.5 5.82031 8.48047 5.74219 8.44141C5.67188 8.39453 5.61328 8.33203 5.56641 8.25391C5.51953 8.17578 5.49609 8.09375 5.49609 8.00781C5.49609 7.91406 5.51953 7.82812 5.56641 7.75C5.61328 7.67188 5.67188 7.61328 5.74219 7.57422C5.82031 7.52734 5.90625 7.50391 6 7.50391C6.14062 7.50391 6.25781 7.55078 6.35156 7.64453C6.44531 7.73828 6.49219 7.85547 6.49219 7.99609C6.49219 8.13672 6.44531 8.25781 6.35156 8.35938C6.25781 8.45312 6.14062 8.5 6 8.5ZM5.01562 4.16406C4.98438 4.25 4.93359 4.32422 4.86328 4.38672C4.80078 4.44141 4.72266 4.48047 4.62891 4.50391C4.54297 4.51953 4.45703 4.51172 4.37109 4.48047C4.29297 4.44922 4.22266 4.39844 4.16016 4.32812C4.09766 4.25781 4.05859 4.17969 4.04297 4.09375C4.03516 4.00781 4.04688 3.92188 4.07812 3.83594C4.25 3.36719 4.53906 3.01562 4.94531 2.78125C5.35156 2.53906 5.80078 2.45312 6.29297 2.52344C6.78516 2.61719 7.18359 2.84766 7.48828 3.21484C7.79297 3.57422 7.94922 4.00391 7.95703 4.50391C7.95703 4.82422 7.87109 5.11328 7.69922 5.37109C7.52734 5.62109 7.28906 5.84375 6.98438 6.03906C6.71875 6.21875 6.42969 6.36328 6.11719 6.47266C5.98438 6.51172 5.85547 6.50391 5.73047 6.44922C5.61328 6.38672 5.53125 6.28906 5.48438 6.15625C5.44531 6.02344 5.45312 5.89844 5.50781 5.78125C5.57031 5.65625 5.66797 5.57031 5.80078 5.52344C6.02734 5.44531 6.23828 5.33984 6.43359 5.20703C6.77734 4.97266 6.94922 4.73438 6.94922 4.49219C6.94922 4.25 6.87109 4.03906 6.71484 3.85938C6.56641 3.67188 6.36719 3.55859 6.11719 3.51953C5.875 3.48047 5.65234 3.51953 5.44922 3.63672C5.24609 3.75391 5.10156 3.92969 5.01562 4.16406Z"
        fill={fill}
      />
    </svg>
  );
};
